import { FontWeight, Size } from '../../../styles/theme.mjs';
import agnosticStyled from '../../../utils/agnosticStyled.mjs';
import styled from 'styled-components';

const StyledText = agnosticStyled `
  color: ${props => (props === null || props === void 0 ? void 0 : props.color) || props.theme.colors.textColor};
  font-weight: ${props => props.theme.typography.fontWeight[props.fontWeight || FontWeight.Regular]};
  font-size: ${props => { var _a; return (_a = props.theme.typography.text[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.fontSize; }};
  line-height: ${props => { var _a; return (_a = props.theme.typography.text[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.lineHeight; }};
`;
const StyledQuotedText = styled(StyledText) `
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  font-style: ${props => props.theme.typography.fontStyle.italic};
  font-size: ${props => props.theme.typography.text[props.size || Size.Small].fontSize};
`;

export { StyledQuotedText, StyledText };
//# sourceMappingURL=Text.styles.mjs.map
